/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_UndoInputs */

const en_action_undo = /** @type {(inputs: Action_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const ar_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const he_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const ur_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const es_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const fr_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const de_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const pt_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const hi_action_undo = en_action_undo;

/** @type {(inputs: Action_UndoInputs) => LocalizedString} */
const bn_action_undo = en_action_undo;

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Action_UndoInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const action_undo = /** @type {((inputs?: Action_UndoInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_UndoInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_action_undo(inputs)
	if (locale === "he") return he_action_undo(inputs)
	if (locale === "ur") return ur_action_undo(inputs)
	if (locale === "es") return es_action_undo(inputs)
	if (locale === "fr") return fr_action_undo(inputs)
	if (locale === "de") return de_action_undo(inputs)
	if (locale === "pt") return pt_action_undo(inputs)
	if (locale === "hi") return hi_action_undo(inputs)
	if (locale === "bn") return bn_action_undo(inputs)
	return /** @type {LocalizedString} */ ("Undo")
});